import styled from "@emotion/styled"
import { ReactElement } from "react"

const Styled = {
  Header: styled.div`
    position: relative;
    line-height: 0;
  `,
  Image: styled.img`
    width: 100%;
    object-fit: cover;
    height: 149px;
    ${(p) => p.theme.breakpoints.up("md")} {
      height: 254px;
    }
  `,
  Gradient: styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.62)
    );
  `,
  Title: styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  `,
}
type BannerProps = {
  url: string
  title: ReactElement
}

const Banner = ({ url, title }: BannerProps) => (
  <Styled.Header>
    <Styled.Image src={url} />
    <Styled.Gradient />
    <Styled.Title>{title}</Styled.Title>
  </Styled.Header>
)

export default Banner
